import { useCallback, useMemo } from "react";
import { toast } from "sonner";
import { useMarkTimelineNotificationsReadMutation } from "web_myplann/Api/NotificationCenter/useMarkTimelineNotificationsReadMutation";
import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { collectUnreadNotificationIds } from "web_myplann/NotificationCenter/Utils/collectUnreadNotificationIds";

type UseMarkDisplayedAsReadResult = {
	hasUnread: boolean;
	markAll: () => void;
	isPending: boolean;
};

export const useMarkDisplayedAsRead = (
	displayedItems: readonly TimelineItemResponseDTO[],
): UseMarkDisplayedAsReadResult => {
	const { t } = useResource();
	const { mutate, isPending } = useMarkTimelineNotificationsReadMutation();

	const unreadIds = useMemo(
		() => collectUnreadNotificationIds(displayedItems),
		[displayedItems],
	);

	const markAll = useCallback(() => {
		if (unreadIds.length === 0) {
			return;
		}
		mutate(
			{ notificationIds: unreadIds },
			{
				onError: () => {
					toast.error(t(Resources.Common.somethingWentWrong));
				},
			},
		);
	}, [unreadIds, mutate, t]);

	return { hasUnread: unreadIds.length > 0, markAll, isPending };
};
